import axiosClient from "../../../../../../axiosClient"

export default async (preCheckId) => {
    const result = await axiosClient.get(`/pre-check-uscis-case-statuses/${preCheckId}`)
    return result.data
}
